/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtrLogWithInfo } from '../../models/dtr-log-with-info';

export interface ApiTapioGetDtrLogsByDatePagedGet$Json$Params {
  CLIENT_ID?: string;
  DATE_FROM?: string;
  page_size?: number;
  page_no?: number;
  Authorization?: string;
}

export function apiTapioGetDtrLogsByDatePagedGet$Json(http: HttpClient, rootUrl: string, params?: ApiTapioGetDtrLogsByDatePagedGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DtrLogWithInfo>>> {
  const rb = new RequestBuilder(rootUrl, apiTapioGetDtrLogsByDatePagedGet$Json.PATH, 'get');
  if (params) {
    rb.query('CLIENT_ID', params.CLIENT_ID, {});
    rb.query('DATE_FROM', params.DATE_FROM, {});
    rb.query('page_size', params.page_size, {});
    rb.query('page_no', params.page_no, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DtrLogWithInfo>>;
    })
  );
}

apiTapioGetDtrLogsByDatePagedGet$Json.PATH = '/api/Tapio/GetDtrLogsByDatePaged';
